import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import MainLayout from "../components/MainLayout";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import FileUploadDynamic from "../ReusableComponents/FileUploadDynamic";
import { mainTable } from "../css/Common";
import MainPopup from "../popup-containers/MainPopup";
import { IoInformationCircle } from "react-icons/io5";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Checkbox from "../ReusableComponents/Checkbox";
import RadioGroup from "../ReusableComponents/RadioButton";
import toast from "react-hot-toast";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";
import { downloadQuestionsXLExportHeader } from "../components/HeaderAttribute";

const AnswerQuestions = () => {
  const [answerQuestions, setAnswerQuestions] = useState([]);
  const [attachmentFilesData, setAttachmentFilesData] = useState([]);
  const [attachmentFilesValidData, setAttachmentFilesValidData] = useState([]);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [selectedModule, setSelectedModule] = useState(6);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState("bottom");

  const iconRef = useRef(null);
  const tooltipRef = useRef(null);
  const [totalAttachmentSize, setTotalAttachmentSize] = useState(0);
  const [eachAttachmentSize, setEachAttachmentSize] = useState(0);
  const [helpPopUpOpen, setHelpPopUpOpen] = useState(false);
  const [buttonEnable, setButtonEnable] = useState(null);
  const [selectedTopicInfo, setSelectedTopicInfo] = useState("");
  const [bindQuestionsMasterDatas, setBindQuestionsMasterDatas] = useState([]);
  const [buttonDisabledStates, setButtonDisabledStates] = useState({});
  const [answerFields, setAnswerFields] = useState({
    topic: "",
    relevanceApplicability: "",
    relevance: [],
    coverageApplicability: "",
    coverage: "",
    answers: [],
  });
  const childRefs = useRef({});
  const [modulesBindDD, setModulesBindDD] = useState([]);
  const [topicBindDD, setTopicBindDD] = useState([]);
  const [coverageBindDD, setCoverageBindDD] = useState([]);
  const [relevanceBindDD, setRelevanceBindDD] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isTopic, setIsTopic] = useState(true);
  const createdBy = sessionStorage.getItem("createdBy");
  const partnerId = sessionStorage.getItem("partnerId");

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      // ✅ Ensure topic 1 shows only on first load

      try {
        const moduleResponse = await BindAPI("AnswerQuestionsAPI/bindModule");
        const modules = moduleResponse?.data?.Table;
        const systemSettingsData = moduleResponse?.data?.Table1?.[0];

        setTotalAttachmentSize(
          systemSettingsData?.TotalAttachmentFilesForAPartner
        );
        setEachAttachmentSize(systemSettingsData?.SizeForFileAttachment);

        if (Array.isArray(modules)) {
          const formattedModules = modules.map((item) => ({
            value: item?.MstModuleId,
            label: item?.ModuleName,
            relevance: item?.Relevance,
            coverage: item?.Coverage,
          }));
          setModulesBindDD(formattedModules);
        }

        await fetchQuestions();

        const responseQuestions = await BindAPI("QuestionsAPI/BindQuestions");
        setBindQuestionsMasterDatas(responseQuestions.data?.Table);
      } catch (err) {
        console.error("Error during data fetch", err);
      }

      setIsLoading(false);
    };

    fetchData();
  }, []);

  const fetchQuestions = async () => {
    const data = { MstPartnerId: partnerId };

    const response = await BindPostAPI(
      data,
      "AnswerQuestionsAPI/BindAnswerQuestions"
    );

    const questions = response?.data?.Table || [];
    const relevance = response?.data?.Table1 || [];
    const coverage = response?.data?.Table2 || [];
    const answers = response?.data?.Table3 || [];
    const topic = localStorage.getItem("lastSavedTopic");
    const attachments = response?.data?.Table5 || [];

    setAnswerQuestions(questions);
    handleModuleChange(selectedModule);
    // Attachments data handling
    const uniqueUrls = Array.from(
      new Map(attachments.map((item) => [item.AttachedDocument, item])).values()
    );
    setAttachmentFilesData(uniqueUrls);

    const counts = attachments.reduce((acc, item) => {
      acc[item.AttachedDocument] = (acc[item.AttachedDocument] || 0) + 1;
      return acc;
    }, {});
    const duplicateItems = attachments.filter(
      (item) => counts[item.AttachedDocument] > 1
    );
    const duplicateMap = new Map(
      duplicateItems.map((item) => [item.AttachedDocument, item])
    );
    setAttachmentFilesValidData(Array.from(duplicateMap.values()));

    setButtonEnable(answers?.[0]?.CompletionStatus ? true : false);

    // Bind dropdowns
    if (Array.isArray(relevance)) {
      const formattedRelevance = relevance.map((item) => ({
        value: item?.MstRelevanceValueId,
        label: item?.RelevanceValue,
      }));
      setRelevanceBindDD(formattedRelevance);
    }

    if (Array.isArray(coverage)) {
      const formattedCoverage = coverage.map((item) => ({
        value: item?.MstCoverageValueId,
        label: item?.CoverageValue,
      }));
      setCoverageBindDD(formattedCoverage);
    }

    // ✅ Set answerFields with default topic = 1 if isTopic is true
    setAnswerFields({
      topic: isTopic ? 13 : topic || "",
      relevanceApplicability: answers?.[0]?.MstRelevanceapplicabilityID || "",
      // relevance: answers?.[0]?.MstRelevanceValueId || "",
      coverageApplicability: answers?.[0]?.MstCoverageapplicabilityID || "",
      coverage: answers?.[0]?.MstCoverageValueId || "",
      answers: [],
    });

  };
  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  useEffect(() => {
    if (showTooltip && iconRef.current && tooltipRef.current) {
      const iconRect = iconRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      // Check if tooltip goes beyond right edge
      let newLeft = 0;
      if (iconRect.left + tooltipRect.width > screenWidth) {
        // Position tooltip to the left of the icon
        newLeft = screenWidth - tooltipRect.width - 10; // 10px padding from right edge
      } else {
        newLeft = iconRect.left;
      }

      // Check vertical position: if there's not enough space below, show above
      if (iconRect.bottom + tooltipRect.height > screenHeight) {
        setTooltipPosition("top");
      } else {
        setTooltipPosition("bottom");
      }
    }
  }, [showTooltip]);
  const handleModuleChange = async (MstModuleId) => {
    setAnswerFields({
      ...answerFields,
      topic: "",
    });
    const data = {
      MstModuleId: MstModuleId,
      MstPartnerId: partnerId,
    };
    const topicResponse = await BindPostAPI(
      data,
      "AnswerQuestionsAPI/BindAnswerQuestionsTopics"
    );
    const topics = topicResponse?.data?.Table; // Expecting an array
    const filteredTopics = topics.filter(
      (item) => item.MstModuleId == MstModuleId
    );
    if (Array.isArray(filteredTopics)) {
      const formattedTopics = filteredTopics.map((item) => ({
        value: item?.MstTopicId,
        label: item?.TopicName,
        relevanceValue: item?.MstRelevanceValueId
          ? item?.MstRelevanceValueId.split(",")?.map(Number)
          : [],
      }));

      setTopicBindDD(formattedTopics);
    }
  };

  const filteredQuestions = useMemo(() => {
    return selectedModule
      ? answerQuestions?.filter((q) => q.MstModuleId == selectedModule)
      : [];
  }, [selectedModule, answerQuestions]);

  const groupedQuestions = useMemo(() => {
    return filteredQuestions?.reduce((acc, item) => {
      if (!acc[item?.QuestionsNo]) acc[item?.QuestionsNo] = [];
      acc[item?.QuestionsNo].push(item);
      return acc;
    }, {});
  }, [filteredQuestions]);

  const filteredTopicQuestions = useMemo(() => {
    return answerFields.topic
      ? Object.values(groupedQuestions)
        .flat()
        .filter((q) => q.MstTopicId == answerFields.topic)
      : [];
  }, [groupedQuestions, answerFields.topic]);

  const groupedTopicQuestions = useMemo(() => {
    const grouped = filteredTopicQuestions.reduce((acc, item) => {
      const key = item?.QuestionsNo;

      if (!acc[key]) {
        acc[key] = {
          data: { ...item },
          attachments: [],
        };
      }

      acc[key].attachments.push({
        file: null,
        url: item?.AttachedDocument,
        pages: item?.IndicatedPages,
        comment: item?.AnswerQuestionsRemarks,
        type: item?.DocumentType,
      });

      return acc;
    }, {});

    return Object.entries(grouped).reduce((result, [key, value]) => {
      result[key] = [{ ...value.data, attachments: value.attachments }];
      return result;
    }, {});
  }, [filteredTopicQuestions]);
  useEffect(() => {
    if (groupedTopicQuestions && Object.keys(groupedTopicQuestions).length) {
      const updatedSelectedAnswers = { ...selectedAnswers };

      Object.entries(groupedTopicQuestions).forEach(([questionNo, items]) => {
        if (!items.length) return;
        const question = items[0];

        const isFlagChecked = question.Flag === 2;

        if (isFlagChecked) {
          // ✅ If Flag === 2 (check), set selectedAnswers[questionNo] with the answer value in array
          updatedSelectedAnswers[questionNo] = [question.Answer];
        } else if (question.Flag === 1) {
          // ✅ If Flag === 1 (uncheck), remove from selectedAnswers
          delete updatedSelectedAnswers[questionNo];
        }
      });
      setIsTopic(false);
      setSelectedAnswers(updatedSelectedAnswers);
    }
  }, [groupedTopicQuestions]);
  const handleRelevanceChange = (updatedOptions) => {
    setAnswerFields({
      ...answerFields,
      relevance: updatedOptions,
    });
  };
  useEffect(() => {
    if (answerFields.topic && topicBindDD?.length > 0) {
      const selectedTopic = topicBindDD.find(
        (x) => x.value === answerFields.topic
      );

      if (
        selectedTopic &&
        selectedTopic.relevanceValue &&
        JSON.stringify(selectedTopic.relevanceValue) !==
        JSON.stringify(answerFields.relevance)
      ) {
        setAnswerFields((prev) => ({
          ...prev,
          relevance: selectedTopic.relevanceValue,
        }));
      }
    }

    // ✅ Scroll to last saved question
    const storedQuestionNo = localStorage.getItem("lastCheckedQuestionNo");
    if (storedQuestionNo) {
      const target = document.getElementById(storedQuestionNo);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [answerFields.topic, topicBindDD]);

  const handleChange = (questionNo, answer) => {
    setSelectedAnswers((prev) => {
      const currentAnswers = prev[questionNo] || [];

      let updatedAnswers;
      if (currentAnswers.includes(answer)) {
        // ✅ Remove the answer if already selected (checkbox unchecked)
        updatedAnswers = currentAnswers.filter((a) => a !== answer);
      } else {
        // ✅ Add the answer if not selected (checkbox checked)
        updatedAnswers = [...currentAnswers, answer];
      }

      // ✅ Disable the Save button when there are *no* selected answers
      setButtonDisabledStates((prevDisabled) => ({
        ...prevDisabled,
        [questionNo]: updatedAnswers.length === 0, // true = disabled when empty
      }));

      return {
        ...prev,
        [questionNo]: updatedAnswers,
      };
    });
  };

  const handleValues = (yy) => {
    setAnswerFields((prev) => ({
      ...prev,
      answers: yy,
    }));
  };

  // const handleSave = async (
  //   questionId,
  //   txnAnswerQuestionsId,
  //   flag,
  //   questionNo,
  //   answers,
  //   checkAnswerData,
  //   remove
  // ) => {
  //   
  //   try {
  //     setIsLoading(true);
  //     setIsTopic(false);
  //     let uploadSuccess;

  //     if (!checkAnswerData) {
  //       uploadSuccess = await childRef.current?.handleUploadSubmit();
  //     }

  //     if (checkAnswerData ? true : uploadSuccess) {
  //       const isValid = childRef.current?.validateAndSubmit();

  //       if (isValid) {
  //         const replaceEmptyWithNull = (obj) => {
  //           return Object.fromEntries(
  //             Object.entries(obj).map(([key, value]) => [
  //               key,
  //               value === "" ? null : value,
  //             ])
  //           );
  //         };

  //         const rawPayload = {
  //           TxnAnswerQuestionsId: txnAnswerQuestionsId || 0,
  //           MstPartnerId: partnerId,
  //           AnsweringDate: new Date(),
  //           MstModuleId: selectedModule,
  //           MstTopicId: answerFields.topic,
  //           MstRelevanceapplicabilityID: answerFields.relevanceApplicability,
  //           MstRelevanceValueId: Array.isArray(answerFields.relevance)
  //             ? answerFields.relevance.join(",")
  //             : answerFields.relevance || null,
  //           MstCoverageapplicabilityID: answerFields.coverageApplicability,
  //           MstCoverageValueId: answerFields.coverage,
  //           QuestionAnswersChild: checkAnswerData
  //             ? JSON.stringify(answers)
  //             : JSON.stringify(answerFields.answers),
  //           MstQuestionsId: questionId,
  //           Flag: flag,
  //           CreatedBy: createdBy,
  //         };
  //         localStorage.setItem("lastSavedModule", selectedModule);
  //         localStorage.setItem("lastSavedTopic", answerFields.topic);
  //         const payload = replaceEmptyWithNull(rawPayload);

  //         const response = await IUDAPI(
  //           payload,
  //           "AnswerQuestionsAPI/IUDAnswerQuestions"
  //         );

  //         const result = response?.data?.Table?.[0]?.Result;

  //         if (flag === 1 && result === "S") {
  //           setIsTopic(false);
  //           // ✅ Clear after success
  //           setAnswerQuestions([]);
  //           fetchQuestions();

  //           toast.success("Data added successfully 👍", {
  //             duration: 2000,
  //             position: "top-center",
  //           });
  //         } else if (flag === 2 && result === "M") {
  //           if (remove === 3) {
  //             setAnswerFields((prev) => ({
  //               ...prev,
  //               answers: [],
  //             }));
  //             setIsTopic(false);
  //             setAnswerQuestions([]);
  //             fetchQuestions();

  //             toast.success("Data Deleted successfully 👍", {
  //               duration: 2000,
  //               position: "top-center",
  //             });
  //           } else {
  //             setAnswerFields((prev) => ({
  //               ...prev,
  //               answers: [],
  //             }));
  //             setIsTopic(false);
  //             setAnswerQuestions([]);
  //             fetchQuestions();

  //             toast.success("Data updated successfully 👍", {
  //               duration: 2000,
  //               position: "top-center",
  //             });
  //           }
  //         } else {
  //           toast.error("Failed to save data 👎", {
  //             duration: 2000,
  //             position: "top-center",
  //           });
  //         }
  //       }
  //     } else {
  //       toast.error("File upload failed. Please check and try again.", {
  //         duration: 2000,
  //         position: "top-center",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("handleSave error:", error);
  //     toast.error("Something went wrong during save.", {
  //       duration: 2000,
  //       position: "top-center",
  //     });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSave = async (
    questionId,
    txnAnswerQuestionsId,
    flag,
    questionNo,
    answers,
    checkAnswerData,
    remove
  ) => {
    debugger;

    try {
      setIsLoading(true);

      setIsTopic(false);

      // ✅ Get correct ref for this question
      const currentRef =
        childRefs.current[questionNo];

      // ✅ Validate only current question
      const isValid =
        currentRef?.validateAndSubmit();

      if (!isValid) {
        toast.error(
          "Please fill all required fields.",
          {
            duration: 2000,
            position: "top-center",
          }
        );

        return;
      }

      // ✅ Default upload result
      let uploadResult = {
        success: true,
        uploadedItems:
          answerFields.answers || [],
      };

      // ✅ Upload only current question files
      if (!checkAnswerData) {
        uploadResult =
          await currentRef?.handleUploadSubmit();
      }

      // ✅ Stop if upload failed
      if (!uploadResult?.success) {
        toast.error(
          "File upload failed. Please check and try again.",
          {
            duration: 2000,
            position: "top-center",
          }
        );

        return;
      }

      // ✅ Replace empty strings with null
      const replaceEmptyWithNull = (
        obj
      ) => {
        return Object.fromEntries(
          Object.entries(obj).map(
            ([key, value]) => [
              key,
              value === ""
                ? null
                : value,
            ]
          )
        );
      };

      // ✅ IMPORTANT
      // Use uploaded items from CURRENT QUESTION ONLY
      const uploadedAnswers =
        checkAnswerData
          ? answers
          : uploadResult.uploadedItems;

      console.log(
        "FINAL UPLOADED ANSWERS",
        uploadedAnswers
      );

      const rawPayload = {
        TxnAnswerQuestionsId:
          txnAnswerQuestionsId || 0,

        MstPartnerId: partnerId,

        AnsweringDate: new Date(),

        MstModuleId: selectedModule,

        MstTopicId: answerFields.topic,

        MstRelevanceapplicabilityID:
          answerFields.relevanceApplicability,

        MstRelevanceValueId:
          Array.isArray(
            answerFields.relevance
          )
            ? answerFields.relevance.join(
              ","
            )
            : answerFields.relevance ||
            null,

        MstCoverageapplicabilityID:
          answerFields.coverageApplicability,

        MstCoverageValueId:
          answerFields.coverage,

        // ✅ Correct current question data
        QuestionAnswersChild:
          JSON.stringify(
            uploadedAnswers
          ),

        MstQuestionsId: questionId,

        Flag: flag,

        CreatedBy: createdBy,
      };

      localStorage.setItem(
        "lastSavedModule",
        selectedModule
      );

      localStorage.setItem(
        "lastSavedTopic",
        answerFields.topic
      );

      const payload =
        replaceEmptyWithNull(
          rawPayload
        );

      console.log(
        "FINAL SAVE PAYLOAD",
        payload
      );

      const response = await IUDAPI(
        payload,
        "AnswerQuestionsAPI/IUDAnswerQuestions"
      );

      const result =
        response?.data?.Table?.[0]
          ?.Result;

      // ✅ INSERT SUCCESS
      if (
        flag === 1 &&
        result === "S"
      ) {
        setIsTopic(false);

        setAnswerQuestions([]);

        await fetchQuestions();

        toast.success(
          "Data added successfully 👍",
          {
            duration: 2000,
            position: "top-center",
          }
        );
      }

      // ✅ UPDATE SUCCESS
      else if (
        flag === 2 &&
        result === "M"
      ) {
        setAnswerFields((prev) => ({
          ...prev,
          answers: [],
        }));

        setIsTopic(false);

        setAnswerQuestions([]);

        await fetchQuestions();

        if (remove === 3) {
          toast.success(
            "Data deleted successfully 👍",
            {
              duration: 2000,
              position: "top-center",
            }
          );
        } else {
          toast.success(
            "Data updated successfully 👍",
            {
              duration: 2000,
              position: "top-center",
            }
          );
        }
      }

      // ✅ FAILED
      else {
        toast.error(
          "Failed to save data 👎",
          {
            duration: 2000,
            position: "top-center",
          }
        );
      }
    } catch (error) {
      console.error(
        "handleSave error:",
        error
      );

      toast.error(
        "Something went wrong during save.",
        {
          duration: 2000,
          position: "top-center",
        }
      );
    } finally {
      setIsLoading(false);
    }
  };




  const handleTopicClick = useCallback(
    (topicId) => {
      const foundTopic = topicBindDD.find((x) => x.value == topicId);
      setAnswerFields((prev) => ({
        ...prev,
        topic: topicId,
        relevance: foundTopic?.relevanceValue || [],
      }));
    },
    [topicBindDD] // 👈 ADD THIS to avoid stale closure
  );

  const handleExport = () => {
    exportData(
      downloadQuestionsXLExportHeader.map((column) => column.title),
      bindQuestionsMasterDatas
    );
  };

  const exportData = (columns, rows) => {
    const titleRow = [
      {
        v: "Download Questions",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    const spacingRow = [{ v: "" }];

    const headerRow = columns.map((column) => ({
      v: column,
      s: {
        fill: { fgColor: { rgb: "000000" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        {
          v: index + 1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ModuleName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TopicNumber,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TopicName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.QuestionNumber,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Question,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Guidance.replace(/<[^>]*>/g, "").trim(),
          s: {
            ...baseStyle,
            alignment: { horizontal: "left", wrapText: true },
          },
        },
        {
          v: (rowData.TopicInformation ?? "").replace(/<[^>]*>/g, "").trim(),
          s: {
            ...baseStyle,
            alignment: { horizontal: "left", wrapText: true },
          },
        },
        {
          v: "",
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: "",
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
      ];
    });

    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Dynamically calculate column widths
    const getMaxColumnWidths = (data) => {
      const colCount = data[2].length; // assuming header row has all columns
      const colWidths = [];

      for (let col = 0; col < colCount; col++) {
        let maxLen = data.reduce((max, row) => {
          const cell = row[col];
          const len = cell?.v ? cell.v.toString().length : 0;
          return Math.max(max, len);
        }, 10); // minimum width
        colWidths.push({ width: maxLen + 2 }); // padding
      }

      return colWidths;
    };
    const guidanceMaxWidth = Math.min(
      Math.max(
        ...rows.map(
          (r) => (r.Guidance?.replace(/<[^>]*>/g, "").length || 0) / 1.5
        )
      ),
      96
    );
    ws["!cols"] = [
      { width: 8 },
      { width: 18 },
      { width: 30 },
      { width: 40 },
      { width: 15 },
      { width: 96 },
      { width: 96 }, // dynamic width with cap
      { width: 20 },
      { width: 20 },
      { width: 30 },
    ];

    // Set row heights
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 15 },
      { hpt: 15 },
      { hpt: 15 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    // Apply borders
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Download Questions.xlsx");
  };

  const renderedTopics = new Set();
  return (
    <MainLayout pageName="4">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      <div class="my-1 max-lg:mt-4 mx-2 lg:mx-4 text-xl font-medium text-neutral-700">
        Answer Questions
      </div>
      {buttonEnable != null && !buttonEnable && (
        <div>
          <div class="flex justify-between gap-10 max-lg:mt-1 mx-2 lg:mx-4 text-xs text-red-500 italic">
            <div className="flex align-middle">
              Click one of the modules to proceed
            </div>
            <div className="flex items-center gap-1">
              <button
                type="button"
                className={mainTable.moduleButton}
                onClick={handleExport}
              >
                Download Questions To Prepare Answers Offline
              </button>
            </div>
          </div>

          <div className="px-4 py-2 space-y-8">
            <div className="flex flex-wrap gap-2 mb-1">
              {modulesBindDD.map((option) => (
                <span
                  key={option.value}
                  onClick={() => {
                    setAnswerFields({
                      ...answerFields,
                      topic: "",
                      relevanceApplicability: option.relevance,
                      coverageApplicability: option.coverage,
                    });

                    setSelectedModule(option.value);
                    handleModuleChange(option.value);
                  }}
                  className={`px-3 py-1 text-sm rounded-full border cursor-pointer ${selectedModule == option.value
                    ? "bg-blue-500 text-white border-blue-500"
                    : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"
                    }`}
                >
                  {option.label}
                </span>
              ))}
            </div>
            {selectedModule && (
              <div className="flex justify-center">
                <div className="p-4 rounded-xl shadow-md border border-gray-200 bg-white text-neutral-700">
                  {(() => {
                    if (
                      !Array.isArray(filteredQuestions) ||
                      filteredQuestions.length === 0
                    ) {
                      return (
                        <p className="max-lg:mt-1 mx-2 lg:mx-4 text-xs font-semibold">
                          No questions found.
                        </p>
                      );
                    }

                    const totalTopicCounts = {};
                    const totalTracker = {};

                    filteredQuestions.forEach((q) => {
                      const topicId = q.MstTopicId;
                      const questionNo = q.QuestionsNo;

                      if (topicId != null && questionNo != null) {
                        totalTracker[topicId] =
                          totalTracker[topicId] || new Set();

                        if (!totalTracker[topicId].has(questionNo)) {
                          totalTracker[topicId].add(questionNo);
                          totalTopicCounts[topicId] =
                            (totalTopicCounts[topicId] || 0) + 1;
                        }
                      }
                    });

                    const answeredTopicCounts = {};
                    const answeredTracker = {};

                    filteredQuestions.forEach((q) => {
                      const topicId = q.MstTopicId;
                      const questionNo = q.QuestionsNo;

                      if (topicId != null && q.TxnAnswerQuestionsId != null) {
                        answeredTracker[topicId] =
                          answeredTracker[topicId] || new Set();

                        if (!answeredTracker[topicId].has(questionNo)) {
                          answeredTracker[topicId].add(questionNo);
                          answeredTopicCounts[topicId] =
                            (answeredTopicCounts[topicId] || 0) + 1;
                        }
                      }
                    });

                    delete answeredTopicCounts._countedIds;

                    const topicNames = {};
                    filteredQuestions.forEach((q) => {
                      if (q.MstTopicId != null && !topicNames[q.MstTopicId]) {
                        topicNames[q.MstTopicId] =
                          q.TopicName || `Topic ${q.MstTopicId}`;
                      }
                    });

                    return (
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-y-1 gap-x-10">
                        {Object.entries(totalTopicCounts).map(
                          ([topicId, totalCount]) => {
                            const answeredCount =
                              answeredTopicCounts[topicId] || 0;
                            const topicName =
                              topicNames[topicId] || `Topic ${topicId}`;

                            let colorClass = "text-red-600";
                            if (answeredCount === totalCount) {
                              colorClass = "text-green-600";
                            } else if (answeredCount > 0) {
                              colorClass = "text-orange-500";
                            }

                            return (
                              <div
                                key={topicId}
                                className="flex justify-between gap-x-1"
                              >
                                <p
                                  onClick={() => handleTopicClick(topicId)}
                                  className="cursor-pointer max-lg:mt-1 mx-2 lg:mx-4 text-xs font-semibold text-gray-600 hover:underline"
                                >
                                  {topicName}
                                </p>
                                <p
                                  className={`font-semibold max-lg:mt-1 mx-2 lg:mx-4 text-xs ${colorClass}`}
                                >
                                  {answeredCount}/{totalCount}
                                </p>
                              </div>
                            );
                          }
                        )}
                      </div>
                    );
                  })()}
                </div>
              </div>
            )}
            <div class="grid gap-x-4 mb-2 md:grid-cols-3">
              <AutoDropDown
                title="Topic"
                options={topicBindDD ? topicBindDD : []}
                placeholder="Select"
                name="topic"
                selectedOption={
                  answerFields.topic
                    ? topicBindDD.find((x) => x.value == answerFields.topic)
                    : ""
                }
                Class="custom-class"
                tabIndex="1"
                classStar="text-red-500"
                controlFunc={(value, e) => {
                  const rValue = value.relevanceValue;
                  setAnswerFields({
                    ...answerFields,
                    relevance: rValue,
                    topic: value.value,
                  });
                }}
              />
            </div>
            {Object.entries(groupedTopicQuestions).map(
              ([questionNo, items]) => {
                const topicKey = `${items[0].TopicNo}-${items[0]?.TopicName}`;
                // Skip rendering if this topic was already shown
                if (renderedTopics.has(topicKey)) return null;
                renderedTopics.add(topicKey);
                // const lines = items[0].TopicInformation.replace(/<[^>]*>/g, "") // Removes all HTML tags
                //   .split("\n")
                //   .map((line) => line.trim())
                //   .filter((line) => line !== "");
                const lines = items[0].TopicInformation.replace(/<\/p>/g, "\n") // Replace closing tags with new lines
                  .replace(/<p>/g, "") // Remove opening tags
                  .replace(/^\s+|\s+$/gm, "") // Trim whitespace on each line
                  .split("\n") // Split into array of lines
                  .filter((line) => line.trim() !== ""); // Remove empty lines

                return (
                  <div
                    key={questionNo}
                    className="border p-4 rounded-md shadow-sm"
                  >
                    <h2 className="font-semibold text-lg mb-2 flex items-center">
                      <span className="flex items-center gap-1">
                        {items[0].TopicNo} {items[0].TopicName}
                        <span
                          ref={iconRef}
                          className="relative"
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                        >
                          <IoInformationCircle className="text-2xl text-black cursor-pointer" />

                          {showTooltip && (
                            <div
                              ref={tooltipRef}
                              className={`absolute ${tooltipPosition === "top"
                                ? "bottom-full mb-2 overflow-y-auto max-h-80"
                                : "top-full mt-2 "
                                } 
  left-1/2 -translate-x-1/2 
  md:left-0 md:translate-x-0
  bg-gray-200 text-black rounded-lg px-4 py-3 shadow-md max-w-xs md:w-96 z-10 text-sm font-normal `}
                            >
                              {lines.map((line, index) => (
                                <p
                                  key={index}
                                  className="max-lg:mt-1 mx-2 lg:mx-4 text-xs italic font-normal"
                                >
                                  {line.trim()}
                                </p>
                              ))}
                            </div>
                          )}
                        </span>
                      </span>
                    </h2>
                    <div className="text-sm mb-1 text-gray-500">
                      {items[0].TopicGuidance.replace(/<[^>]*>/g, "").trim()}
                    </div>
                    {items[0].Relevance == 1 && (
                      <div>
                        <Checkbox
                          classDiv="flex"
                          ClassLabel="flex items-center block font-medium mb-1 gap-1"
                          Class="grid grid-cols-2 md:grid md:grid-cols-6 lg:grid lg:grid-cols-6 items-center gap-3 bg-gray-50 pl-4"
                          ClassLabelInput="flex items-center gap-1"
                          Class1="flex items-center gap-1"
                          title="Relevance:"
                          // classStar="text-red-500"
                          type={"checkbox"}
                          setName={"relevance"}
                          selectedOptions={
                            answerFields.relevance ? answerFields.relevance : []
                          }
                          options={relevanceBindDD}
                          controlFunc={handleRelevanceChange}
                          tabIndex="0"
                        />
                      </div>
                    )}
                    {selectedModule == 0 && (
                      <div>
                        <RadioGroup
                          classDiv="flex gap-[1.3rem]"
                          classLabel="flex items-center block font-medium mb-1 "
                          Class="grid grid-cols-2 md:grid md:grid-cols-6 lg:grid lg:grid-cols-6 items-center gap-1 bg-gray-50 pl-4"
                          ClassLabel="flex items-center"
                          Class1="flex items-center gap-x-11"
                          title="Coverage:"
                          classStar="text-red-500"
                          type={"checkbox"}
                          setName={"relevance"}
                          selectedOptions={answerFields.relevance}
                          options={coverageBindDD}
                          controlFunc={handleRelevanceChange}
                          tabIndex="0"
                        />
                      </div>
                    )}
                  </div>
                );
              }
            )}
            {Object.entries(groupedTopicQuestions).map(
              ([questionNo, items]) => {
                if (!items.length) return null;

                const question = items[0];
                // Get the current values directly from state
                const questionId = question.MstQuestionsId;
                let txnAnswerQuestionsId = question.TxnAnswerQuestionsId;
                let currentFlag = question.Flag;

                // Determine if checkbox should be selected:
                const isSelected =
                  selectedAnswers[questionNo]?.includes(question.Answer) ||
                  (txnAnswerQuestionsId !== null &&
                    !selectedAnswers[questionNo]);
                const lines = items[0].Guidance.replace(/<\/p>/g, "\n") // Replace closing tags with new lines
                  .replace(/<p>/g, "") // Remove opening tags
                  .replace(/^\s+|\s+$/gm, "") // Trim whitespace on each line
                  .split("\n") // Split into array of lines
                  .filter((line) => line.trim() !== ""); // Remove empty lines

                return (
                  <div
                    id={questionNo}
                    key={`q-${questionNo}-${txnAnswerQuestionsId}`}
                    className="border p-4 rounded-md shadow-sm"
                  >
                    {/* Entire block inside label for better UX */}
                    <div className="flex items-start gap-2 mb-2">
                      <label className="flex items-start gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          name={`question-${questionNo}`}
                          value={question.Answer}
                          checked={isSelected}
                          onChange={() => {
                            handleChange(questionNo, question.Answer);
                            localStorage.setItem(
                              "lastCheckedQuestionNo",
                              questionNo
                            );
                          }}
                          className="mt-1"
                        />
                      </label>
                      <div>
                        <div className="font-medium">
                          {question.QuestionsNo} {question.Questions}
                        </div>
                        {question.Guidance && (
                          <div className="text-sm text-gray-500 mt-2">
                            {question.Guidance.replace(/<[^>]*>/g, "").trim()}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Attachments section if checkbox is selected */}
                    {isSelected && (
                      <div className="mt-4 ml-6 space-y-4">
                        {items.map((item, idx) => (
                          <FileUploadDynamic
                            key={`upload-${idx}-${txnAnswerQuestionsId}`}
                            ref={(el) => {
                              childRefs.current[item?.QuestionsNo] = el;
                            }}
                            questionNumber={item?.QuestionsNo}
                            partnerId={partnerId}
                            createdBy={createdBy}
                            individualFileSize={eachAttachmentSize}
                            totalFileSize={totalAttachmentSize}
                            defaultAttachments={item?.attachments}
                            txnAnswerQuestionsId={txnAnswerQuestionsId}
                            currentFlag={currentFlag}
                            questionId={questionId}
                            attachmentFilesData={attachmentFilesData}
                            onRemove={(newItems, checkAnswerData) => {
                              handleSave(
                                questionId,
                                txnAnswerQuestionsId,
                                currentFlag,
                                item?.QuestionsNo,
                                newItems,
                                checkAnswerData,
                                3
                              );
                              localStorage.setItem(
                                "lastCheckedQuestionNo",
                                item?.QuestionsNo
                              );
                            }}
                            attachmentFilesValidData={attachmentFilesValidData}
                            values={handleValues}
                            setParentButtonDisabled={(disabled) => {
                              setButtonDisabledStates((prev) => ({
                                ...prev,
                                [item?.QuestionsNo]: disabled,
                              }));
                            }}
                          />
                        ))}
                      </div>
                    )}

                    <div className="mt-4 ml-6 flex justify-end space-x-2">
                      {items.map((item, idx) => (
                        <button
                          key={`save-btn-${idx}-${item?.QuestionsNo}`}
                          onClick={() => {
                            handleSave(
                              questionId,
                              txnAnswerQuestionsId,
                              currentFlag,
                              item?.QuestionsNo
                            );

                            // ✅ Save this question ID in localStorage
                            localStorage.setItem(
                              "lastCheckedQuestionNo",
                              item?.QuestionsNo
                            );
                          }}
                          disabled={
                            buttonDisabledStates[item?.QuestionsNo] !== false
                          } // ✅ Default disabled, enable only if explicitly set to false
                          className={`px-4 py-1 rounded text-white ${buttonDisabledStates[item?.QuestionsNo] !== false
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-gray-600 hover:bg-gray-700"
                            }`}
                        >
                          {"Save"}
                        </button>
                      ))}
                    </div>
                  </div>
                );
              }
            )}
          </div>
        </div>
      )}
      {buttonEnable && (
        <div className="border p-4 lg:mx-4 rounded-md shadow-sm">
          <div className="mb-2 text-xs text-red-500 italic flex justify-center">
            You have already submited the answer for assessment. You can not
            modify.
          </div>
        </div>
      )}
      <MainPopup
        popUpOpen={helpPopUpOpen}
        setpopUpOpen={setHelpPopUpOpen}
        Open={() => setHelpPopUpOpen(true)}
      >
        <div class="flex flex-col p-4">
          <button className="w-full">
            <span
              className="text-white flex justify-end"
              onClick={() => setHelpPopUpOpen(false)}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <label class="mb-1">{selectedTopicInfo}</label>

          <div className={mainTable.submitCancelMainDiv}>
            <button
              data-modal-hide="bottom-right-modal"
              type="button"
              className={mainTable.cancelButton}
              onClick={() => setHelpPopUpOpen(false)}
            >
              CANCEL
            </button>
          </div>
        </div>
      </MainPopup>
    </MainLayout>
  );
};

export default AnswerQuestions;
